import { useState, useEffect } from "react";
import { Ard, UslLine } from "@amzn/fuse-accounting-central-datastore-client";
import { BLANK_ARD } from "src/components/constants/appConstants";
import { ModalMode } from "src/context/jem-gen/types";

export const useFormDataManagement = (
  ardData: Ard | null,
  modalMode: ModalMode,
) => {
  const [formData, setFormData] = useState<Ard | null>(null);

  useEffect(() => {
    if (modalMode === ModalMode.CREATE) {
      setFormData({ ...BLANK_ARD });
    } else if (modalMode === ModalMode.DUPLICATE && ardData) {
      setFormData({ ...ardData, id: "" });
    } else if (ardData) {
      setFormData({ ...ardData });
    }
  }, [ardData, modalMode]);

  const handleChange = (field: keyof Ard, value: string) => {
    if (formData) {
      setFormData({
        ...formData,
        [field]: value,
      });
    }
  };

  const handleUslLineChange = (
    useCaseIndex: number,
    lineIndex: number,
    field: keyof UslLine,
    value: string,
  ) => {
    if (formData && formData.usecases) {
      const updatedUsecases = [...formData.usecases];
      const useCase = updatedUsecases[useCaseIndex];

      if (useCase && useCase.uslLines) {
        const updatedLines = [...useCase.uslLines];
        updatedLines[lineIndex] = {
          ...updatedLines[lineIndex],
          [field]: value,
        };

        updatedUsecases[useCaseIndex] = {
          ...useCase,
          uslLines: updatedLines,
        };

        setFormData({
          ...formData,
          usecases: updatedUsecases,
        });
      }
    }
  };

  return {
    formData,
    setFormData,
    handleChange,
    handleUslLineChange,
  };
};
